/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileUploadAnswerValue } from '../models/FileUploadAnswerValue';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FormResponseFileUploadService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Submit an answer to a file upload form element.
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element to answer.
     * @param orgGuid
     * @param repeatableGroupGuid The repeatable group guid.
     * @param formGuid
     * @param formData
     * @returns FileUploadAnswerValue OK
     * @throws ApiError
     */
    public submitFileUpload(
        responseGuid: string,
        formElementGuid: string,
        orgGuid: string,
        repeatableGroupGuid: string,
        formGuid: string,
        formData?: {
            /**
             * The file.
             */
            file?: Blob;
        },
    ): CancelablePromise<Array<FileUploadAnswerValue>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/fileupload/{formElementGuid}/{orgGuid}/{repeatableGroupGuid}/SubmitFileUpload',
            path: {
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
                'orgGuid': orgGuid,
                'repeatableGroupGuid': repeatableGroupGuid,
                'formGuid': formGuid,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete an answer to a file upload form element.
     * @param responseGuid The response's guid.
     * @param formElementGuid The form element to answer.
     * @param repeatableGroupGuid The repeatable group guid.
     * @param formGuid
     * @param fileGuid The file to delete.
     * @returns FileUploadAnswerValue OK
     * @throws ApiError
     */
    public deleteFileUpload(
        responseGuid: string,
        formElementGuid: string,
        repeatableGroupGuid: string,
        formGuid: string,
        fileGuid?: string,
    ): CancelablePromise<Array<FileUploadAnswerValue>> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/mwforms/{formGuid}/responses/{responseGuid}/fileupload/{formElementGuid}/{repeatableGroupGuid}/DeleteFileUpload',
            path: {
                'responseGuid': responseGuid,
                'formElementGuid': formElementGuid,
                'repeatableGroupGuid': repeatableGroupGuid,
                'formGuid': formGuid,
            },
            query: {
                'fileGuid': fileGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
